// ===== IMPORTS =====
// jQuery - expose-loader ho exportuje do window.$, window.jQuery
import $ from 'jquery';
import 'jquery-ui';

// jQuery plugins (Uniform, Carousel, Magnific Popup, atd.)
import './jquery.plugins.js';

// Knihovny
import tippy from 'tippy.js';
import iziToast from 'izitoast';
import 'izimodal';
import 'gasparesganga-jquery-loading-overlay';

// Project moduly
import './eshop/fedcm.js';
import './eshop/ares.js';
import './eshop/catalog.js';
import './eshop/order.js';
import { ReloadAjax, ParamAjax } from './eshop/ReloadAjax.js';
import './eshop/ruian.js';
import './eshop/toDelete.js';
import './eshop/gtag';
import './components/menu.js';
import './components/categories-nav.js';
import {productSwiper} from './components/swiper.js';
import './components/filter.js';
import './components/tabs.js';
import './components/cart.js';
import './components/search.js';
import './components/searchSuggest.js';
import './components/footer.js';
import './components/lazyLoad';

// ===== GLOBALNI EXPORTY =====
// Pro kompatibilitu se starym kodem
window.iziToast = iziToast;
window.tippy = tippy;
window.productSwiper = productSwiper;

// ===== JQUERY EXTENSIONS =====
$.fn.hasAttr = function(name) {
	return this.attr(name) !== undefined;
};

// ===== MAIN CODE =====
$(document).ready(function() {
	// TODO - sjednotit tooltip pluginy
	// TODO vyhodit cluetip plugin z vendor/jquery.plugins-original.js
	// Tippy tooltips
	tippy('.tippy', {
		interactive: true,
		theme: 'autochladek',
	});

	// Tooltips
	$(".tooltip").cluetip({
		splitTitle: '|',
		showTitle: false,
		tracking: true,
		topOffset: 40,
		leftOffset: 15,
	});
});

// ===== HEUREKA WIDGET =====
const h = window.innerHeight;
const topMarg = h > 450 ? (h - 450) / 2 : 10;

var _hwq = _hwq || [];
_hwq.push(['setKey', '9AD4A12AFEACD531C68016ADA7DE97B8']);
_hwq.push(['setTopPos', topMarg + '']);
_hwq.push(['showWidget', '22']);
(function() {
	const ho = document.createElement('script');
	ho.type = 'text/javascript';
	ho.async = true;
	ho.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.heureka.cz/direct/i/gjs.php?n=wdgt&sak=9AD4A12AFEACD531C68016ADA7DE97B8';
	const s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(ho, s);
})();
